module.exports = {"130432100":"广平镇","130432101":"平固店镇","130432102":"胜营镇","130432103":"南阳堡镇","130432104":"十里铺镇","130432105":"南韩镇","130432106":"东张孟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130432.json
// module id = 210
// module chunks = 0